// extracted by mini-css-extract-plugin
export default {"inputs":"AddBook_inputs__gDsI7","submit_btn":"AddBook_submit_btn__v8kei"};